import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Whether the message list uses the enlarged sender-image (persona) sizing and
 * the matching header/row/rollup alignment.
 *
 * This was originally gated on `mon-type-ramp` alone, but `tri-mlCheckboxBehavior`
 * ships the same enlarged sender image (see `getPersonaSizeForMLRow`)
 * independently. Any surface that aligns to that leading edge must use this
 * predicate so it stays aligned if `tri-mlCheckboxBehavior` rolls out ahead of
 * `mon-type-ramp`.
 *
 * Note: this is for *alignment* only. Pure typography (font size/weight/color)
 * should remain gated on `mon-type-ramp` via `useIsTypeRampUpdatesEnabled`.
 */
export const isBigPersonaLayoutEnabled = (): boolean => isGlobalFeatureEnabled("mon-type-ramp") || isGlobalFeatureEnabled("tri-mlCheckboxBehavior");
